import Headponne from '../../assets/images/v2/headphone-right.png'
const HeadphoneRight = (props)=>{
    return(
       <img src={Headponne}  style={{width:"75%"}} alt="" />
    )
}
export default HeadphoneRight